(function () {
  'use strict';

  /* @ngdoc object
   * @name journal
   * @description
   *
   */
  angular
    .module('journal', [
      'ui.router'
    ]);
}());
